import { Button } from '@e2n/ui/v2';
import { useCreateVorlageAbschnitt } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useCreateVorlageAbschnitt/useCreateVorlageAbschnitt';
import type { RotationsplanVorlageDetails } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlageById/useRotationsplanVorlageById';
import { toast } from '@/hooks/use-toast';
import * as Sentry from '@sentry/react';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const TRANSLATION_PREFIX =
  'domain.mitarbeiter.rotationsplan.rotationsplaene.createAbschnitt';

export function CreateVorlageAbschnitt({
  vorlage,
}: {
  vorlage: RotationsplanVorlageDetails;
}) {
  const { t } = useTranslation();
  const [createVorlageAbschnitt] = useCreateVorlageAbschnitt();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const istLehrjahr = vorlage.beruf.istAusbildung;
  const art = istLehrjahr ? 'lehrjahr' : 'abschnitt';

  async function handleClick() {
    setIsSubmitting(true);

    try {
      const result = await createVorlageAbschnitt({
        input: {
          vorlageId: vorlage.id,
          name: istLehrjahr ? 'Lehrjahr' : 'Abschnitt',
          position: vorlage.abschnitte.length + 1,
        },
      });

      if (result.data?.mitarbeiter_createVorlageAbschnitt.success) {
        toast({ title: t(`${TRANSLATION_PREFIX}.success.${art}`) });
      } else {
        toast({
          variant: 'destructive',
          title: t(`${TRANSLATION_PREFIX}.error.${art}`),
        });
      }
    } catch (error) {
      Sentry.captureException(error);
      toast({
        variant: 'destructive',
        title: t(`${TRANSLATION_PREFIX}.error.${art}`),
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="px-1 py-2 border-dashed border-neutrals-v2-400 border rounded-xl">
      <Button
        disabled={isSubmitting}
        className="w-full"
        variant="ghost-on-grey"
        onClick={handleClick}>
        <FontAwesomeIcon icon={faPlus} className="size-4.5" />
        {istLehrjahr
          ? t(`${TRANSLATION_PREFIX}.labelJahr`)
          : t(`${TRANSLATION_PREFIX}.labelAbschnitt`)}
      </Button>
    </div>
  );
}
